import { render, staticRenderFns } from "./ResourcesHome.vue?vue&type=template&id=13fc2fa2&scoped=true&"
import script from "./ResourcesHome.vue?vue&type=script&lang=js&"
export * from "./ResourcesHome.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesHome.vue?vue&type=style&index=0&id=13fc2fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc2fa2",
  null
  
)

export default component.exports